import * as React from "react";
const SvgLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 6L9 12L15 18", stroke: "currentColor" }));
export default SvgLeft;
